import type { Episode } from "../api/types";

export type EpisodeRange = {
  page: number;
  cursor: string | null;
  title: string;
  hint: string;
};

export function buildEpisodeRanges(
  totalEpisodes: number,
  pageSize = 20,
): EpisodeRange[] {
  const totalPages = Math.ceil(totalEpisodes / pageSize);
  return Array.from({ length: totalPages }, (_, index) => {
    const page = index + 1;
    const start = index * pageSize + 1;
    const end = Math.min(page * pageSize, totalEpisodes);
    return {
      page,
      cursor: page === 1 ? null : String(page),
      title: `选择第 ${start} 到第 ${end} 集`,
      hint: `第 ${page} 组，共 ${totalPages} 组`,
    };
  });
}

export function displayEpisodeTitle(
  episode: Episode,
  fallbackSeriesTitle?: string,
) {
  const title = episode.title.trim();
  if (/^第\s*\d+\s*集$/.test(title) && fallbackSeriesTitle) {
    return `${fallbackSeriesTitle} ${title}`;
  }
  return title;
}

export function historyForPage(page: number): (string | null)[] {
  return Array.from({ length: page - 1 }, (_, index) =>
    index === 0 ? null : String(index + 1),
  );
}
